import Quit from './src/components/Quit.vue'
import Rewards from './src/components/Rewards.vue'
import UnitPrice from './src/components/UnitPrice.vue'
import ImagePopup from './src/components/ImagePopup.vue'
import BaseCenterPopup from './src/components/BaseCenterPopup.vue'
import PayOnBehalfOfPosterPopup from './src/components/PayOnBehalfOfPosterPopup.vue'

import RAd, * as adRouter from './src/router/RAd'
import RFission, * as fissionRouter from './src/router/RFission'
import RFissionS3, * as fissionS3Router from './src/router/RFissionS3'
import RPersonalIncome, * as personalIncomeRouter from './src/router/RPersonalIncome'
import RSemesterReport, * as semesterReportRouter from './src/router/RSemesterReport'
import RFissionAdvanced, * as fissionAdvancedRouter from './src/router/RFissionAdvanced'

import RFCL from './src/router/RFCL'
import RTGC from './src/router/RTGC'
import RRank from './src/router/RRank'
import RBingo from './src/router/RBingo'
import RSplus from './src/router/RSplus'
import RFitCat from './src/router/RFitCat'
import RSFruit from './src/router/RSFruit'
import RPacman from './src/router/RPacman'
import RDouyin from './src/router/RDouyin'
import RAdFree from './src/router/RAdFree'
import RParkour from './src/router/RParkour'
import RKoiFish from './src/router/RKoiFish'
import RUniverse from './src/router/RUniverse'
import RDouble11 from './src/router/RDouble11'
import RStarWish from './src/router/RStarWish'
import RRecharge from './src/router/RRecharge'
import ROlympics from './src/router/ROlympics'
import RFruitCut from './src/router/RFruitCut'
import RSuperHero from './src/router/RSuperHero'
import RHwClockIn from './src/router/RHwClockIn'
import RBlastHero from './src/router/RBlastHero'
import RChristmas from './src/router/RChristmas'
import RFinalExam from './src/router/RFinalExam'
import RSports618 from './src/router/RSports618'
import RHallowmas from './src/router/RHallowmas'
import RSuperArena from './src/router/RSuperArena'
import RMysteryBox from './src/router/RMysteryBox'
import RSportsTree from './src/router/RSportsTree'
import RWinterCamp from './src/router/RWinterCamp'
import RSportsCard from './src/router/RSportsCard'
import RSplusMatch from './src/router/RSplusMatch'
import RSportsGame from './src/router/RSportsGame'
import RTeachersDay from './src/router/RTeachersDay'
import RSchoolMatch from './src/router/RSchoolMatch'
import RChildrenDay from './src/router/RChildrenDay'
import RNationalDay from './src/router/RNationalDay'
import RJumpForGold from './src/router/RJumpForGold'
import RFightCovid19 from './src/router/RFightCovid19'
import RExamTest2021 from './src/router/RExamTest2021'
import RDailySharing from './src/router/RDailySharing'
import RMagicAcademy from './src/router/RMagicAcademy'
import RBlastBattery from './src/router/RBlastBattery'
import RAnnualReport from './src/router/RAnnualReport'
import RFallSemester from './src/router/RFallSemester'
import RSpringOuting from './src/router/RSpringOuting'
import RSportsIsland from './src/router/RSportsIsland'
import RDragonKnight from './src/router/RDragonKnight'
import RJumpropeMatch from './src/router/RJumpropeMatch'
import RMetaSvS2025 from './src/activity/jumprope-match/RMetaSvS2025'
import RTaishan2026 from './src/activity/jumprope-match/RShandongTaishan2026'
import RHealthTest2021 from './src/router/RHealthTest2021'
import RDuanwuFestival from './src/router/RDuanwuFestival'
import RIceCreamFactory from './src/router/RIceCreamFactory'
import RJumpropePartner from './src/router/RJumpropePartner'
import RSplusDragonCard from './src/router/RSplusDragonCard'
import RThanksgivingDay from './src/router/RThanksgivingDay'
import RSplusGroupBuying from './src/router/RSplusGroupBuying'
import RCookingMasterBoy from './src/router/RCookingMasterBoy'
import RTwelveZodiacSigns from './src/router/RTwelveZodiacSigns'
import RAerobicGymnastics from './src/router/RAerobicGymnastics'
import RSpriteMagicTroupe from './src/router/RSpriteMagicTroupe'
import RSummerVacation2022 from './src/router/RSummerVacation2022'
import RFightSquareSoldier from './src/router/RFightSquareSoldier'
import REnduranceChallenge from './src/router/REnduranceChallenge'
import RFightSquareSoldier2 from './src/router/RFightSquareSoldier2'
import RXiyangyangGiftPacks from './src/router/RXiyangyangGiftPacks'
import RSummerVacation2023Homework from './src/router/RSummerVacation2023Homework'
import RFIFA2022 from './src/router/RFIFA2022'
import RActivity202401 from './src/router/RActivity202401'
import RActivity202405 from './src/router/RActivity202405'
import RActivity202407 from './src/router/RActivity202407'
import RActivity202408 from './src/router/RActivity202408'
import RActivity202503 from './src/router/RActivity202503'
import RPurchaseJumpropeCourse from './src/activity/202507/RPurchaseJumpropeCourse'
import RMaritimeTrade2025 from './src/activity/202508/RMaritimeTrade'
import RGelamonInvite from './src/activity/202509/RGelamonInvite'

import RExam2023, * as exam2023Router from './src/router/RExam2023'
import RGymnastic, * as gymnasticRouter from './src/router/RGymnastic'
import RLogistics, * as logisticsRouter from './src/router/RLogistics'
import RGiftPacks, * as giftPacksRouter from './src/router/RGiftPacks'
import RSummerCamp, * as summerCampRouter from './src/router/RSummerCamp'
import RSportsMeeting, * as sportsMeetingRouter from './src/router/RSportsMeeting'
import ROnlineMatches, * as onlineMatchesRouter from './src/router/ROnlineMatches'
import RSchoolMatches, * as schoolMatchesRouter from './src/router/RSchoolMatches'
import RSummerVacation, * as summerVacationRouter from './src/router/RSummerVacation'
import RWinterVacation, * as winterVacationRouter from './src/router/RWinterVacation'
import RWinterVacation2023, * as winterVacationRouter2023 from './src/router/RWinterVacation2023'
import RWinterVacation2024, * as winterVacationRouter2024 from './src/activity/202412/RWinterVacation'
import RWinterVacation2025, * as winterVacationRouter2025 from './src/activity/202512/RWinterVacation'
import RWinterVacation2023Excellent, * as winterVacationRouter2023Excellent from './src/router/RWinterVacation2023Excellent'
import RWinterVacation2023Homework, * as winterVacationRouter2023Homework from './src/router/RWinterVacation2023Homework'
import RNewTermPlan202402, * as newTermPlanRouter202402 from './src/router/RNewTermPlan202402'
import RNewTermPlan202502, * as newTermPlanRouter202502 from './src/activity/202502/RSpringNewTermPlan'
import RCutFruitPromo2025, * as cutFruitPromoRouter2025 from './src/activity/202505/cut-fruit-promotion/RCutFruitPromo'
import RExchangeReward202402, * as exchangeRewardRouter202402 from './src/router/RExRewardSco202402'
import RExchangeReward202409, * as exchangeRewardRouter202409 from './src/router/RExRewardSco202409'
import RExchangeReward202412, * as exchangeRewardRouter202412 from './src/activity/202412/RWinter2024ExchangeRewardScore'
import RSummerVacation2024HomeworkTea, * as summerVacationRouter2024HomeworkTea from './src/router/RSummerVacation2024HomeworkTea'
import RSummerVacation2024HomeworkStu, * as summerVacationRouter2024HomeworkStu from './src/router/RSummerVacation2024HomeworkStu'
import RPePoints2025SummerStu from './src/activity/pe-points/RPePoints2025SummerStu'
import RSummerVacation2025 from './src/activity/202506/RSummerVacation'
import RActivityTeacher2024 from './src/router/RActivityTeacher2024'
import RWorkContest202403, * as workContestRouter202403 from './src/router/RWorkContest202403'
import RCommonSharePage, * as commonSharePageRouter from './src/router/RCommonShare'
import RAutumnPoints2025 from './src/activity/202508/RAutumnPoints2025'
import RWinterPoints2025 from './src/activity/202512/RWinterPoints2025'
import RNewTerm2026, * as newTermRouter2026 from './src/activity/202601/RNewTerm2026'
import RWinterVacation2026Report, * as winterVacation2026ReportRouter from './src/activity/202601/RWinterVacation2026Report'

import RCourseLive2022, * as courseLive2022Router from './src/router/RCourseLive2022'
import RSportsMeetings, * as sportsMeetingsRouter from './src/router/RSportsMeetings'
import RExamCompetition, * as examCompetitionRouter from './src/router/RExamCompetition'
import RFallSemester2021, * as fallSemester2021Router from './src/router/RFallSemester2021'
import RSpringSemester2022, * as springSemester2022Router from './src/router/RSpringSemester2022'
import RFujianJumpRopeMatch, * as fujianJumpRopeMatchRouter from './src/router/RFujianJumpRopeMatch'
import RSportsMeetingSignup, * as sportsMeetingSignupRouter from './src/router/RSportsMeetingSignup'
import RSportsMeetingWarmup, * as sportsMeetingWarmupRouter from './src/router/RSportsMeetingWarmup'
import RTheMidAutumnFestival, * as theMidAutumnFestivalRouter from './src/router/RTheMidAutumnFestival'
import RLessonPlanCollection, * as lessonPlanCollectionRouter from './src/router/RLessonPlanCollection'
import RBroadcastGymnastics2022, * as broadcastGymnastics2022Router from './src/router/RBroadcastGymnastics'
import RJumpropeRefereeTraining, * as jumpropeRefereeTrainingRouter from './src/router/RJumpropeRefereeTraining'
import RSummerVacation2022Homework, * as summerVacation2022HomeworkRouter from './src/router/RSummerVacation2022Homework'
import RSeniorHighSchoolEntranceExam, * as seniorHighSchoolEntranceExamRouter from './src/router/RSeniorHighSchoolEntranceExam'

import RCNNewYear from './src/router/RCNNewYear'
import RLanternFestival from './src/router/RLanternFestival'
import RLeads, * as leadsRouter from './src/router/RLeads'
import RInviteTeacherStudent2022, * as inviteTeacherStudent2022 from './src/router/RInviteTeacherStudent2022'
import RSummer2022Competition, * as summer2022Competition from './src/router/RSummer2022Competition'
import RMedalChallenge from './src/router/RMedalChallenge'
import RSportsTrail, * as sportsTrailRouter from './src/router/RSportsTrail'
import RWinter2023ExcellenceSelection, * as winter2023ExcellenceSelectionRouter from './src/router/RWinter2023ExcellenceSelection'
import RMatchJiangyin202506 from './src/router/RMatchJiangyin202506'
import RPrizeSolicitation from './src/router/RPrizeSolicitation'

export { default as RSummerVacation2025Homework } from './src/router/RSummerVacation2025Homework'
export { default as RNewSemester2025 } from './src/activity/202508/RNewSemester2025'

export {
  RFission,
  RFissionS3,
  RPersonalIncome,
  RSemesterReport,
  RSportsMeetingSignup,
  RSeniorHighSchoolEntranceExam,
  fissionRouter,
  fissionS3Router,
  personalIncomeRouter,
  semesterReportRouter,
  sportsMeetingSignupRouter,
  seniorHighSchoolEntranceExamRouter,
}

export { RSummerCamp, summerCampRouter }

export { RCourseLive2022, courseLive2022Router }

export { RSportsMeeting, sportsMeetingRouter }

export { RSportsMeetingWarmup, sportsMeetingWarmupRouter }

export { RAd, adRouter }

export { ROnlineMatches, onlineMatchesRouter }

export { RSchoolMatches, schoolMatchesRouter }

export { RExamCompetition, examCompetitionRouter }

export { RFissionAdvanced, fissionAdvancedRouter }

export { RSummerVacation, summerVacationRouter }

export { RWinterVacation, winterVacationRouter }

export { RWinterVacation2023, winterVacationRouter2023 }

export { RWinterVacation2023Excellent, winterVacationRouter2023Excellent }

export { RWinterVacation2023Homework, winterVacationRouter2023Homework }

export { RWinterVacation2024, winterVacationRouter2024 }

export { RWinterVacation2025, winterVacationRouter2025 }

export { RNewTermPlan202402, newTermPlanRouter202402 }

export { RNewTermPlan202502, newTermPlanRouter202502 }

export { RNewTerm2026, newTermRouter2026 }
export { RWinterVacation2026Report, winterVacation2026ReportRouter }

export { RCutFruitPromo2025, cutFruitPromoRouter2025 }

export { RWorkContest202403, workContestRouter202403 }

export { RCommonSharePage, commonSharePageRouter }

export { RSummerVacation2024HomeworkTea, summerVacationRouter2024HomeworkTea }

export { RActivityTeacher2024 }

export { RSportsMeetings, sportsMeetingsRouter }

export { RHealthTest2021 }

export { RExamTest2021 }

export { RExam2023, exam2023Router }

export { RGymnastic, gymnasticRouter }

export { RLogistics, logisticsRouter }

export { RGiftPacks, giftPacksRouter }

export { RFallSemester2021, fallSemester2021Router }

export { RSpringSemester2022, springSemester2022Router }

export { RSummerVacation2022Homework, summerVacation2022HomeworkRouter }

export { RTheMidAutumnFestival, theMidAutumnFestivalRouter }

export { RLessonPlanCollection, lessonPlanCollectionRouter }

export { RJumpropeRefereeTraining, jumpropeRefereeTrainingRouter }

export { RFujianJumpRopeMatch, fujianJumpRopeMatchRouter }

export { RLeads, leadsRouter }

export { RInviteTeacherStudent2022, inviteTeacherStudent2022 }

export { RSummer2022Competition, summer2022Competition }

export { RMedalChallenge }

export { RBroadcastGymnastics2022, broadcastGymnastics2022Router }

export { RSportsTrail, sportsTrailRouter }

export { RWinter2023ExcellenceSelection, winter2023ExcellenceSelectionRouter }

export const RXiyou = [
  {
    path: '/activity/xiyou',
    name: 'activity_xiyou',
    component: () => import('./src/activity/xiyou/index.vue'),
  },
]

export const components = {
  // multiple lines
  Quit,
  Rewards,
  UnitPrice,
  ImagePopup,
  BaseCenterPopup,
  PayOnBehalfOfPosterPopup,
}

import RXiYangYang from './src/router/RXiYangYang'
export { RXiYangYang }

import RMarketingMatchHeld from './src/router/RMarketingMatchHeld'
export { RMarketingMatchHeld }

export const RApph5Activities = /*#__PURE__*/ [
  ...RSplus,
  ...RSummerCamp,
  ...ROnlineMatches,
  ...RSchoolMatches,
  ...RSportsMeeting,
  ...RSportsMeetingWarmup,
  ...RBingo,
  ...RSuperArena,
  ...RSuperHero,
  ...RTeachersDay,
  ...RTheMidAutumnFestival,
  ...RHealthTest2021,
  ...RSummerVacation2022,
  ...RIceCreamFactory,
  ...RExamTest2021,
  ...RRank,
  ...RUniverse,
  ...RCNNewYear,
  ...RLanternFestival,
  ...RFightCovid19,
  ...RSummerVacation2022Homework,
  ...RMedalChallenge,
  ...RTwelveZodiacSigns,
  ...RXiyou,
  ...RFIFA2022,
  ...RDailySharing,
  ...RFCL,
  ...RTGC,
  ...RJumpForGold,
  ...RWinterVacation2023Homework,
  ...RFitCat,
  ...RDouble11,
  ...RStarWish,
  ...RRecharge,
  ...ROlympics,
  ...RHwClockIn,
  ...RBlastHero,
  ...RChristmas,
  ...RSFruit,
  ...RPacman,
  ...RDouyin,
  ...RAdFree,
  ...RParkour,
  ...RKoiFish,
  ...RFruitCut,
  ...RFinalExam,
  ...RSports618,
  ...RHallowmas,
  ...RMysteryBox,
  ...RXiYangYang,
  ...RSportsTree,
  ...RWinterCamp,
  ...RSportsCard,
  ...RSplusMatch,
  ...RSportsGame,
  ...RSchoolMatch,
  ...RChildrenDay,
  ...RNationalDay,
  ...RMagicAcademy,
  ...RBlastBattery,
  ...RAnnualReport,
  ...RFallSemester,
  ...RSpringOuting,
  ...RSportsIsland,
  ...RDragonKnight,
  ...RJumpropeMatch,
  ...RMetaSvS2025,
  ...RTaishan2026,
  ...RDuanwuFestival,
  ...RJumpropePartner,
  ...RSplusDragonCard,
  ...RThanksgivingDay,
  ...RSplusGroupBuying,
  ...RCookingMasterBoy,
  ...RAerobicGymnastics,
  ...RSpriteMagicTroupe,
  ...RFightSquareSoldier,
  ...REnduranceChallenge,
  ...RFightSquareSoldier2,
  ...RXiyangyangGiftPacks,
  ...RSummerVacation2023Homework,
  ...RActivity202401,
  ...RActivity202405,
  ...RActivity202407,
  ...RActivity202408,
  ...RExchangeReward202402,
  ...RExchangeReward202409,
  ...RExchangeReward202412,
  ...RSummerVacation2024HomeworkStu,
  ...RPePoints2025SummerStu,
  ...RSummerVacation2025,
  ...RActivity202503,
  ...RCutFruitPromo2025,
  ...RMatchJiangyin202506,
  ...RPurchaseJumpropeCourse,
  ...RMaritimeTrade2025,
  ...RAutumnPoints2025,
  ...RGelamonInvite,
  ...RPrizeSolicitation,
  ...RWinterPoints2025,
  {
    path: '/activity/autumn-new-term-2022',
    name: 'autumn_new_term_2022',
    component: () => import('./src/activity/autumn-new-term-2022/index.vue'),
  },
  {
    path: '/activity/hw-check-in/:id',
    name: 'hw-check-in',
    component: () => import('./src/activity/hw-check-in/index.vue'),
    props: true,
  },
  {
    path: '/activity/rpe-evaluate/:id',
    name: 'rpe-evaluate',
    component: () => import('./src/activity/rpe-evaluate/index.vue'),
    props: true,
  },
]

// models
export type {
  // multiple lines
  IActivityData,
  IActivityConfig,
  IActivityLotteryPool,
  IActivityLotteryItem,
} from './src/models/config'

// services
export * as helper from './src/service/helper'
export { useActivity } from './src/service/activityBase'
